var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false ? _c("div", { staticClass: "text-center" }) : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }